import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=c46a5ae2&"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js&"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteClientModal.vue?vue&type=style&index=0&id=c46a5ae2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports